import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const contactsTaxIdViewer = {
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map